import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { handleGetRequest } from '../../utils/api-handler.util'
import { formatTime } from '../../utils/date.util'
import { useState } from 'react'
import DeletePromotionModal from '../../components/admin/DeletePromotionModal'
import InfoGrid from '../../components/common/InfoGrid'

const PromotionDetailsPage = () => {
  const { promotionId } = useParams()
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const { data: promotionDetails } = useQuery({
    queryKey: QueryKeys.adminPromotionDetails(promotionId),
    queryFn: () => handleGetRequest(`/admins/promotions/${promotionId}`),
    enabled: !!promotionId,
  })

  const promotion = promotionDetails?.data

  const handleDelete = () => {
    setDeleteModalOpen(true)
  }

  const promotionInfoItems = [
    { label: 'ID', value: promotion?.id },
    { label: 'Create By', value: promotion?.createdBy },
    { label: 'Create date', value: formatTime(promotion?.createdAt) },
  ]

  const promotionActions = (
    <>
      <div className="flex gap-4 mb-6 w-full justify-end">
        <button
          className="bg-error-600 text-white px-6 py-2 rounded-[4px] font-medium"
          onClick={handleDelete}
        >
          Delete Promotion
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center w-full">
        <img
          src={promotion?.bannerImage}
          alt="Promotion Banner"
          className="w-[300px] h-[220px] object-contain border border-black/20 rounded-[4px]"
        />
      </div>
    </>
  )

  return (
    <div className="w-full mx-auto">
      <InfoGrid infoItems={promotionInfoItems} actions={promotionActions} />

      <DeletePromotionModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        promotionId={promotionId}
      />
    </div>
  )
}

export default PromotionDetailsPage
